import { useCallback, useState } from 'react';
import { isValidPeriod, periodPlaceholder, prophecyTagLabel } from 'src/components/star-grid/utils/snapshotTagLabel';
import type { CreateSnapshotTagRequest, SnapshotTagRow } from 'src/components/star-grid/starGridTypes';

/** The New Tag modal: which snapshot, its deck type and period, and a short description. */
export const useSnapshotTagForm = (prefixes: readonly string[], periodFormats: Readonly<Record<string, string>> = {}) => {
  const [snapshot, setSnapshot] = useState<SnapshotTagRow>();
  const [deckType, setDeckType] = useState('');
  const [period, setPeriod] = useState('');
  const [description, setDescription] = useState('');

  const open = useCallback(
    (row: SnapshotTagRow | undefined) => {
      setSnapshot(row);
      setDeckType((current) => current || prefixes[0] || '');
      setPeriod('');
      setDescription('');
    },
    [prefixes]
  );

  const periodFormat = periodFormats[deckType];
  const periodValid = isValidPeriod(period, periodFormat);
  const request: CreateSnapshotTagRequest | undefined =
    snapshot && deckType && periodValid
      ? { deck_type: deckType, period: period.trim(), snapshot_id: snapshot.snapshot_id, description: description.trim() || undefined }
      : undefined;

  return {
    snapshot,
    visible: Boolean(snapshot),
    close: () => setSnapshot(undefined),
    open,
    deckType,
    setDeckType,
    period,
    setPeriod,
    periodFormat,
    periodPlaceholder: periodPlaceholder(periodFormat),
    periodInvalid: period.trim().length > 0 && !periodValid,
    description,
    setDescription,
    label: periodValid ? prophecyTagLabel(deckType, period, snapshot?.committed_at) : '',
    request
  };
};
